import { Toaster } from "react-hot-toast";
import Portal from "./Portal";

const AppPortalHost = () => (
  <Portal layer="toast">
    <Toaster
      position="bottom-right"
      reverseOrder
      containerStyle={{
        top: "auto",
        bottom: 16,
        right: 16,
        left: "auto",
      }}
      toastOptions={{
        duration: 4000,
        style: {
          borderRadius: "10px",
          fontSize: "14px",
          maxWidth: "420px",
        },
        success: {
          style: {
            background: "var(--background-color3, #fff)",
            color: "var(--mainTextColor, #1a1a1a)",
            border: "1px solid var(--border-color, #e5e5e5)",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
          },
          iconTheme: {
            primary: "#22c55e",
            secondary: "#fff",
          },
        },
        error: {
          style: {
            background: "var(--background-color3, #fff)",
            color: "var(--mainTextColor, #1a1a1a)",
            border: "1px solid var(--border-color, #e5e5e5)",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
          },
          iconTheme: {
            primary: "#ef4444",
            secondary: "#fff",
          },
        },
      }}
    />
  </Portal>
);

export default AppPortalHost;
